import { styled } from '../../theme';
import background from '../../images/background1.jpg';

const PlaceholderImage = styled('div')({
    flex: '1 1 auto',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(${background})`,
});

export default PlaceholderImage;
